/**
 * Les villes du Maroc proposees en liste deroulante, a deux endroits :
 *
 *   - la ville de preference du parcours d'inscription, etape 2, quand aucune session n'est retenue ;
 *   - la ville d'une session, sur sa fiche d'administration.
 *
 * POURQUOI UNE LISTE FERMEE PLUTOT QU'UNE SAISIE LIBRE. Demande de Wahid du 2026-08-20 : « rendre la
 * ville de preference et la ville une liste deroulante avec les plus grandes villes du Maroc ». Ce
 * que la liste fermee empeche, et qui n'a pas ete mesure sur la base de production : deux ecritures
 * d'une meme ville, « Casa » et « Casablanca », que le filtre par ville de l'etape 1 offrirait comme
 * deux villes distinctes, puisqu'il construit ses entrees a partir de la colonne `sessions.ville`.
 *
 * CE QUE LA LISTE CONTIENT : SIX VILLES, ET C'EST WAHID QUI LES NOMME, le 2026-08-20. Elle en
 * portait 42, les communes urbaines les plus peuplees du recensement de 2014 : « il y a trop de
 * villes : garder seulement Casablanca, Rabat, Marrakech, Tanger, El Jadida, Fes ». Ce sont les six
 * villes ou une session peut s'ouvrir, et une liste qui en proposait 42 recueillait des preferences
 * pour des villes ou aucune journee n'aura lieu.
 *
 * ELLES SONT RANGEES PAR ORDRE ALPHABETIQUE, et l'ordre de la demande de Wahid n'est pas conserve :
 * une liste deroulante se parcourt a l'oeil, l'ordre alphabetique dit ou regarder.
 *
 * ⚠️ CE FICHIER NE PORTE AUCUN TEXTE D'INTERFACE. Le libelle du champ et l'entree vide de la liste
 * vivent dans `content/contenu.ts` et `content/administration.ts`, comme tout le reste.
 */
export const VILLES_DU_MAROC: readonly string[] = [
  'Casablanca',
  'El Jadida',
  'Fès',
  'Marrakech',
  'Rabat',
  'Tanger',
];

export default VILLES_DU_MAROC;
